import {PuiTextField} from "@portnet/ui";
import React from "react";

const AppTextField = React.forwardRef((props, ref) => {
  return <PuiTextField ref={ref} {...props} />;
});

export default AppTextField;
